// import ModalForm from "./Form";
import LogTableForm from "./LogTableForm";
import {
	STUDENT_PROFILE_LOG,
	DATATABLE_EXPORT,
} from "../../../../../../../Config/ApiUrl";
import * as actions from "../../../../../../../Config/ApiUrl";

export const Schema = {
	components: { LogTableForm },

	data() {
		return {
			DATATABLE_EXPORT,
			isAddEditModalActive: false,
			deleteConfirmationModalActive: false,
			deleteLoader: false,
			selectedUrl: this.ENDPOINT,
			Endpoint: STUDENT_PROFILE_LOG + "?clc_id_number=" + this.value.clc_id_number,
			tableId: "log-table",
			formId: "log-table-form",
			rowData: {},
			tableColumns: [
				{
					title: "Date",
					type: "text",
					key: "assigned_date",
				},
				{
					title: "Task",
					type: "text",
					key: "title",
				},
				{
					title: "Assigned By",
					type: "custom-html",
					key: "owner_id",
					isVisible: true,
					modifier: (value) => {
						return value?.full_name
					}
				},
				{
					title: "Assign To",
					type: "custom-html",
					key: "assignee_id",
					isVisible: true,
					modifier: (value) => {
						return value?.full_name
					}
				},
				{
					title: "Due Date",
					type: "text",
					key: "due_date",
				},
				{
					title: "Due Time",
					type: "custom-html",
					key: "due_time",
					isVisible: true,
					modifier: (value) => {
						return value?.slice(0, -3)
					}
				},
				{
					title: "Status",
					type: "custom-html",
					key: "stage_id",
					modifier: (value) => {
						return value?.name
					}
				},
			],
			actionObj: {
				title: this.$t("action"),
				type: "action",
			},
			options: {
				name: "LogTable",
				url: STUDENT_PROFILE_LOG + "?clc_id_number=" + this.value.clc_id_number,
				showHeader: true,
				enableHighlights: true,
				// enableRowSelect: true,
				enableSaveFilter: true,
				columns: [],
				actions: [
					{
						title: this.$t("edit"),
						icon: "edit",
						type: "none",
						// component: "app-add-modal",
						component: "log-table-form",
						modalId: "log-table-form",
					},
				],
				showFilter: true,
				showSearch: true,
				showCount: true,
				showClearFilter: true,
				paginationType: "pagination",
				responsive: true,
				rowLimit: 3,
				showAction: true,
				orderBy: "desc",
				actionType: "default",
			},
		};
	},
	methods: {},
};
